import React from 'react';
import hoverManager from '../../../../utils/HoverManager';
import { ColorElement } from '../subcomponents/ColorElement';
import textEditorUtils from '../../utils/TextEditorUtils';

export const ColorPallete = React.createClass({
    showColorPicker() {
        setTimeout(function() {
            textEditorUtils.addColorPickerBackground();

            this.refs.htmlColorPicker.click();
        }.bind(this), 10);
    },
    onColorPickerChangeColor() {
        let color = textEditorUtils.getCorrectColor(this.refs.htmlColorPicker.value);

        this.props.executeCommand(this.props.type, color);
    },
    render() {
        let elementWidth = this.props.gridSize;
        let height = 2 * elementWidth + 2 * this.props.topGap;

        let menuStyle = {
            position: 'absolute',
            top: this.props.top,
            left: 0,
            width: this.props.width,
            height: height
        };

        let listElements = [];

        for (let i=0; i<20; i++) {
            listElements.push(<ColorElement index={i} width={elementWidth} top={this.props.topGap} showColorPicker={this.showColorPicker} type={this.props.type} currentColor={this.props.currentColor} executeCommand={this.props.executeCommand} contextTarget={this.props.contextTarget} key={'colorElement' + i}/>);
        }

        let colorPickerHolderStyle = {
            position: 'absolute',
            top: 50,
            right: 0,
            zIndex: 2000,
            display: 'block',
            pointerEvents: 'none'
        };

        let labelStyle = {
            opacity: 0
        };

        let inputStyle = {
            opacity: 0
        };

        let lineElement;

        if (this.props.type === 'changeFontColor') {
            let lineStyle = {
                position: 'absolute',
                width: this.props.width,
                height: 1,
                top: 2 * elementWidth + 2 * this.props.topGap,
                backgroundColor: '#c4c4c4'
            };

            lineElement = <div style={lineStyle}></div>;
        }

        return (
            <div style={menuStyle}>
                {listElements}

                <div style={colorPickerHolderStyle}>
                    <label htmlFor="htmlColorPicker" style={labelStyle}>{hoverManager.getText('favoriteColor')}</label>
                    <input type="color" id="htmlColorPicker" ref="htmlColorPicker" style={inputStyle} value={this.props.currentColor} onChange={this.onColorPickerChangeColor}/>
                </div>

                {lineElement}
            </div>
        );
    }
});


/** WEBPACK FOOTER **
 ** ./src/components/menus/textEditorTool/components/subcomponents/ColorPallete.js
 **/